import styled, { keyframes } from 'styled-components';
import { skeletonBase, skeletonHighlight } from 'src/styles/colors';

const shimmer = keyframes`
  from { background-position: -400px 0; }
  to { background-position: 400px 0; }
`;

// $inverse renders a translucent-white shimmer for colored backgrounds.
const SkeletonBlock = styled.div`
  flex-shrink: 0;
  background: ${({ $inverse }) => $inverse ?
    `linear-gradient(90deg, rgba(255, 255, 255, 0.25) 25%,
      rgba(255, 255, 255, 0.45) 50%, rgba(255, 255, 255, 0.25) 75%)` :
    `linear-gradient(90deg, ${skeletonBase} 25%,
      ${skeletonHighlight} 50%, ${skeletonBase} 75%)`};
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s linear infinite;
  border-radius: ${({ $radius }) => $radius || '8px'};
  width: ${({ $width }) => $width || '100%'};
  height: ${({ $height }) => $height || '16px'};
`;

export default SkeletonBlock;
